import React, { useEffect, useState } from 'react';
import Button from '../Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  environment,
  RootState,
  renderDescriptionParagraphs,
} from '@rb-serve-app/core';
import { useSelector } from 'react-redux';
import ChangePinInfoModal from '../ChangePin/ChangePinInfoModal';
import ChangePinAndActivateCardModal from '../ChangePin/ChangePinAndActivateCardModal';
import { RightArrow } from '../../assets/svg/ArrowIcon';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

type ActionCardProps = {
  img: any;
  title: string;
  description: string;
  buttonText: string;
  buttonLink?: string;
  customStyle: string;
  onCardClick: () => void;
  featureFlaggingData: any;
  setShowFeatureFlagMessage: React.Dispatch<React.SetStateAction<boolean>>;
  setIsRequestCardOpen: React.Dispatch<React.SetStateAction<boolean>>;
  showInfoModal?: boolean;
  setShowInfoModal?: React.Dispatch<React.SetStateAction<boolean>>;
  currentModal?: string;
  setCurrentModal?: React.Dispatch<React.SetStateAction<string>>;
  insuranceIndicator: any;
};

const ActionCard: React.FC<ActionCardProps> = ({
  img,
  title,
  description,
  buttonText,
  buttonLink,
  customStyle,
  onCardClick,
  featureFlaggingData,
  setShowFeatureFlagMessage,
  setIsRequestCardOpen,
  showInfoModal = false,
  setShowInfoModal,
  currentModal,
  setCurrentModal,
  insuranceIndicator,
}) => {
  const navigate = useNavigate();
  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );
  const { entries } = contentfulData;
  const { rb_manage_card } = entries;
  // const [showInfoModal, setShowInfoModal] = useState(false);
  // const [currentModal, setCurrentModal] = useState('');
  const [isOpenChangePinModal, setIsOpenChangePinModal] = useState(false);
  const {
    isWalletEnabled,
    isUserCanAddCard,
    NotRemindMeLater,
    status: popupStatus,
  } = useSelector((state: RootState) => state.popup);
  const { showActivateCardPopup = null } = popupStatus || {};

  const handleButtonClick = () => {
    console.log('handelClick');
    onCardClick();

    if (!featureFlaggingData) {
      if (window.scrollY !== 0) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      setShowFeatureFlagMessage(true);
      setTimeout(() => setShowFeatureFlagMessage(false), 3000);
      return;
    }

    const cardTitles = rb_manage_card?.manageCardsTiles.card_tiles.map(
      (tile: any, index: number) => {
        if (index === 0 && showActivateCardPopup) {
          return tile?.activate_ctaTitle;
        }
        if (index === 4 && insuranceIndicator) {
          return tile?.ctaTitle_notInsured;
        }
        return tile?.ctaTitle;
      }
    );

    switch (buttonText) {
      case cardTitles?.[1]:
        navigate('/lock-unlock');
        setShowInfoModal?.(false);
        setCurrentModal?.('');
        break;
      case cardTitles?.[0]:
        setCurrentModal?.(
          showActivateCardPopup ? 'activate-card' : 'change-pin'
        );
        setShowInfoModal?.(true);
        break;
      case cardTitles?.[3]:
        navigate('/request-supplementary');
        setShowInfoModal?.(false);
        setCurrentModal?.('');
        break;
      case cardTitles?.[4]:
        navigate('/account-protection');
        setShowInfoModal?.(false);
        setCurrentModal?.('');
        break;
      default:
        setShowInfoModal?.(false);
        setCurrentModal?.('');
        navigate('/manage-card');
    }
  };

  const handleContinue = () => {
    setIsOpenChangePinModal(true);
    setShowInfoModal?.(false);
  };
  const lang = localStorage.getItem('language') == 'fr' ? 'fr' : 'en';
  console.log('title', title);
  return (
    <>
      <div className={customStyle}>
        <div className="hidden md:block">
          <img
            src={img}
            alt={`Icon representing ${title}`}
            className="h-[56px] w-[56px]"
          />
        </div>
        <div className="flex justify-center items-center md:block w-full">
          <div className="flex flex-col gap-1 lg:gap-1 xl:gap-[15px] md:gap-[15px] text-left xl:text-center lg:text-left md:text-center min-h-[120px] md:w-full w-[90%]">
            <h3
              aria-label={renderDescriptionParagraphs(title, undefined, true)}
              className="text-[16px] font-semibold text-[#1F1F1F]"
            >
              {renderDescriptionParagraphs(title)}
            </h3>
            <p
              aria-label={renderDescriptionParagraphs(
                description,
                undefined,
                true
              )}
              className="text-[16px] font-normal text-[#1F1F1F]  items-start xl:items-center md:items-center lg:items-start"
            >
              {renderDescriptionParagraphs(description)}
            </p>
          </div>
          <div className="justify-start xl:justify-center lg:justify-start md:justify-center hidden md:flex mt-1">
            <Button
              ariaLabel={renderDescriptionParagraphs(
                buttonText,
                undefined,
                true
              )}
              variant={`${featureFlaggingData ? 'solid' : 'featureFlag'}`}
              onClick={() => {
                handleButtonClick();
              }}
              // href={featureFlaggingData ? buttonLink : '#'}
              className={`${featureFlaggingData ? 'bg-red-600 text-white' : 'bg-gray-100 border-gray-300 border-2'} text-sm font-medium py-2 px-4`}
            >
              {renderDescriptionParagraphs(buttonText)}
            </Button>
          </div>
          <span
            className="view-text block md:hidden  w-[10%]"
            onClick={() => {
              handleButtonClick();
            }}
            role="button"
          >
            <RightArrow width="24px" height="24px" />
          </span>
        </div>
      </div>
      {showInfoModal && (
        <ChangePinInfoModal
          isOpen={showInfoModal}
          onClose={() => setShowInfoModal?.(false)}
          currentModal={currentModal || ''}
          handleContinue={handleContinue}
        />
      )}
      {isOpenChangePinModal && (
        <GoogleReCaptchaProvider
          reCaptchaKey={environment.recaptchaSiteKey}
          language={lang}
          container={{
            parameters: {
              badge: 'bottomright',
              theme: 'light',
            },
          }}
          scriptProps={{ async: true, defer: true }}
        >
          <ChangePinAndActivateCardModal
            isOpenChangePinModal={isOpenChangePinModal}
            setIsOpenChangePinModal={setIsOpenChangePinModal}
            currentModal={currentModal || ''}
          />
        </GoogleReCaptchaProvider>
      )}
    </>
  );
};

export default ActionCard;
